import {styled} from "styled-components";

export const ListPadding = styled.div`
  height: 8rem;
`;
